import './i18n/config'
import 'react-toastify/dist/ReactToastify.css'
import './ReactToastifyCustom.css'
import 'react-perfect-scrollbar/dist/css/styles.css'
import 'driver.js/dist/driver.css'

import {
  AuthenticationResult,
  EventMessage,
  EventType,
} from '@azure/msal-browser'
import { MsalProvider } from '@azure/msal-react'
import {
  GlobalStyles,
  theme,
  ThemeProvider,
} from '@orobix/orobix-fe-components'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { createRoot } from 'react-dom/client'
import { ThemeProvider as JssThemeProvider } from 'react-jss'
import { BrowserRouter as Router } from 'react-router-dom'
import { Slide, ToastContainer } from 'react-toastify'

import App from './App'
import { msalInstance } from './auth/config'
import LeaveConfirmationPrompt from './components/LeaveConfirmationPrompt/LeaveConfirmationPrompt'
import SettingsProvider from './components/Settings/SettingsContext'
import reportWebVitals from './reportWebVitals'
import { StoreProvider } from './store/store'
import PendingRequestsContextProvider from './utils/apiPendingRequests'

const accounts = msalInstance.getAllAccounts()

if (accounts.length > 0) {
  msalInstance.setActiveAccount(accounts[0])
}

msalInstance.addEventCallback((event: EventMessage) => {
  if (event.eventType === EventType.LOGIN_SUCCESS && event.payload) {
    const payload = event.payload as AuthenticationResult
    const { account } = payload
    msalInstance.setActiveAccount(account)
  }
})

const queryClient = new QueryClient()

// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
const domNode = document.getElementById('root')!
const root = createRoot(domNode)

root.render(
  <MsalProvider instance={msalInstance}>
    <ThemeProvider theme={theme}>
      <JssThemeProvider theme={theme}>
        <GlobalStyles>
          <QueryClientProvider client={queryClient}>
            <StoreProvider>
              <PendingRequestsContextProvider>
                <SettingsProvider>
                  <Router>
                    <App />
                    <LeaveConfirmationPrompt />
                    <ToastContainer
                      position="bottom-right"
                      autoClose={5000}
                      newestOnTop
                      closeOnClick
                      pauseOnFocusLoss
                      draggable
                      pauseOnHover
                      transition={Slide}
                    />
                  </Router>
                </SettingsProvider>
              </PendingRequestsContextProvider>
            </StoreProvider>
          </QueryClientProvider>
        </GlobalStyles>
      </JssThemeProvider>
    </ThemeProvider>
  </MsalProvider>
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
